import {Card,Modal,Form,Col,Row,Space,Button,Divider,Input} from "antd"
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import ContactService from '../../../services/ContactService.js';

export default function SocialNetworksForm({
    isModalVisible,
    handleOk,
    handleCancel,
    contact=null,
    }) {
    const [form] = Form.useForm();
    // const [userAnotherSocialNetworks, setUserAnotherSocialNetworks] = useState([]);

    const updateAnotherSocialNetworks=useCallback((otherSocialNetworks)=>{
        ContactService.updateAnothersocialnetworks(7,otherSocialNetworks).then((res)=>{
            let {success}=res.data;
            if(success){
                handleOk()
                console.log("Se actualizo correctamente")
            }
            else{
                console.error("No se pudo actualizar")
            }
        })
    })

    const onFinish=(value)=>{
        updateAnotherSocialNetworks(value.ListSocialNetworks    )
    }


    // useEffect(()=>{
    //     setUserAnotherSocialNetworks(contact)
    // },[])

    return (
        <>
        <Modal
        open={isModalVisible}
        onOk={handleOk} 
        onCancel={handleCancel}
        title="Editar otras redes sociales"
        footer={null}
        >
            <Form
            form={form}
            name="dynamic_form_nest_item"
            onFinish={onFinish}
            autoComplete="off"
            >
                <Form.List 
                name="ListSocialNetworks"
                initialValue={ contact }
                >
                    {(fields, { add, remove }) => (
                        <Row align="start">
                            { fields.map((field, index) => (
                            <Col
                            // xs={{ span: 20, offset: 2 }}
                            // sm={{ span: 20, offset: 2 }}
                            // md={{ span: 10, offset: 7 }}
                            // lg={{ span: 10, offset: 7 }}
                            // xl={{ span: 10, offset: 7 }}
                            key={field.key}
                            >
                                <Card title={`Rede Social N ${index}`}>
                                    <Space align="baseline" split={<Divider type="vertical"/>} direction="vertical">
                                        <Form.Item
                                        key={`SNNN-${index}`}
                                        label="Nombre de la red social"
                                        {...field}
                                        name={[field.name, "SocialNetworkNewName"]}
                                        rules={[{ required: true, message: "Ingrese el nombre de red social." }]}
                                        >
                                            <Input></Input>
                                        </Form.Item>
                                        <Form.Item
                                        key={`SNNU-${index}`}
                                        label="Nombre de usuario la red social"
                                        {...field}
                                        name={[field.name, "SocialNetworkNewUser"]}
                                        rules={[{ required: true, message: "Ingrese el usuario de esta red social" }]}
                                        >
                                            <Input></Input>
                                        </Form.Item>
                                        <MinusCircleOutlined onClick={() => remove(field.name)} />
                                    </Space>
                                </Card>
                            </Col>
                            ))}
                            <Col span={10} offset={7}>
                                <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    block
                                    icon={<PlusOutlined />}
                                >
                                    Añadir otra red social
                                </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    )}
                </Form.List>
                <Row align="center">
                    <Col
                        xs={{ span: 20 }}
                        sm={{ span: 20 }}
                        md={{ span: 14 }}
                        lg={{ span: 10 }}
                        xl={{ span: 10 }}
                    >
                        <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Registrar los cambios
                        </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
        </>
    )
}